// config
import * as http from 'utils/http';
import config from 'config';

const finishCostNegotiation = async ({ ticketId, quoteId }) => {
  return http.post(
    `${config.API_URL}price-negotiation/tickets/${ticketId}/quotes/${quoteId}/finished_cost_negotiations/`
  );
};

export default finishCostNegotiation;
